export default "<dashboard-menu-list ng-model=\"dashboards\"></dashboard-menu-list>\n"